export default class GalleryController {
    constructor() {
        this.lightGallery = null;
        this.galleries = [];

        this.init();
    }

    init() {
        if (document.querySelectorAll('.mediaGallery').length) {
            import( /* webpackChunkName: "modules/gallery" */ '../libraries/lightgallery/js/lightgallery').then(e => {
                this.lightGallery = window.lightGallery;

                document.querySelectorAll('.mediaGallery').forEach(gallery => {
                    this.galleries.push(new this.lightGallery(gallery, {
                        selector: 'a',
                        download: false,
                        speed: 400,
                        cssEasing: 'easeOut',
                        loop: false,
                        slideEndAnimatoin: false,
                        hideControlOnEnd: true,
                    }));
                });
            });
        }
    }
}